import { Configuration } from '../shared/configuration.model';
import { ConfigurationService } from '../shared/configuration.service';
import { Component, Injectable, OnInit } from '@angular/core';
// import { SharedModule } from '../../app.shared';
import { Router } from '@angular/router';
import { User } from '../shared/User';
import { TicketService } from '../shared/ticketService';
import { LocalStorage } from '../shared/localstorage.service';

@Component({
    templateUrl: './home.component.html'
})

@Injectable()
export class HomeComponent implements OnInit {
    public pageTitle = 'Home Page';
    currentUser = new User();
    private foundConfigs: Configuration[] = [];
    constructor(
        private ticketService: TicketService,
        private _router: Router,
        private localStorage: LocalStorage,
        private configService: ConfigurationService) { }
    ngOnInit() {
        this.currentUser.userName = localStorage.getItem('userName');
        this.currentUser.token = localStorage.getItem('token');
        this.currentUser.role = localStorage.getItem('role');
    }
}
